import React, { Component } from 'react';
import { Button, CircularProgress, TextField, Grid } from '@material-ui/core';
import { isValidPass } from '../../utils/validations';
import { IConfirmationState } from '../../types/Confirmation.types';
import { ILanguageStrings } from '../../utils/languages/languages';

interface ConfirmationProps {
  nextStep: Function;
  previousStep: Function;
  handleChange: Function;
  submitting: Boolean;
  data: IConfirmationState;
  languageStrings: ILanguageStrings;
}

export class Confirmation extends Component<ConfirmationProps, {}> {
  state = {
    error: {
      username: '',
      password: '',
      passwordConfirmation: ''
    }
  };

  nextStep = (e: { preventDefault: () => void; stopPropagation: () => void }) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.nextStep();
  };

  previousStep = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    this.props.previousStep();
  };

  isContinueDisabled = () => {
    const { submitting } = this.props;

    if (typeof submitting === 'boolean' && submitting === true) {
      return submitting;
    } else {
      return !this.isFormValid();
    }
  };

  checkFieldErrors = (field: string, value: string) => {
    if (field === 'username') {
      this.setState((prevState: any) => {
        return {
          error: {
            ...prevState.error,
            [field]: value.length < 8 ? this.props.languageStrings.confirmation.userNameError : ''
          }
        };
      });
    } else {
      this.setState((prevState: any) => {
        return {
          error: {
            ...prevState.error,
            [field]: isValidPass(value) ? '' : this.props.languageStrings.confirmation.passwordError
          }
        };
      });
    }

    if (field === 'passwordConfirmation') {
      this.setState((prevState: any) => {
        return {
          error: {
            ...prevState.error,
            passwordConfirmation:
              this.props.data.password !== value
                ? this.props.languageStrings.confirmation.passwordConfirmationError
                : ''
          }
        };
      });
    }
  };

  isFormValid = () => {
    const { username, password, passwordConfirmation } = this.props.data;
    return (
      username.length >= 8 &&
      isValidPass(password) &&
      isValidPass(passwordConfirmation) &&
      password === passwordConfirmation
    );
  };

  handleFieldChange = (event: { target: { value: string } }, field: string) => {
    this.props.handleChange('confirmation', field, () => this.checkFieldErrors(field, event.target.value))(event);
  };

  renderConfirmationControls = () => {
    return (
      <div className="confirmation-controls">
        <Grid container spacing={3} style={{ width: '100%' }}>
          <Grid item xs={12}>
            <TextField
              required
              id="username"
              name="username"
              label={this.props.languageStrings.confirmation.usernameLabel}
              fullWidth
              autoComplete="user-name"
              variant="outlined"
              error={this.state.error.username.length > 0}
              helperText={this.state.error.username}
              onChange={e => this.handleFieldChange(e, 'username')}
              inputProps={{ 'data-testid': 'username' }}
              value={this.props.data.username}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              type="password"
              required
              id="password"
              name="password"
              label={this.props.languageStrings.confirmation.passwordnameLabel}
              fullWidth
              autoComplete="password"
              variant="outlined"
              error={this.state.error.password.length > 0}
              helperText={this.state.error.password}
              onChange={e => this.handleFieldChange(e, 'password')}
              inputProps={{ 'data-testid': 'password' }}
              value={this.props.data.password}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              type="password"
              required
              id="passwordConfirmation"
              name="passwordConfirmation"
              label={this.props.languageStrings.confirmation.confirmationPassLabel}
              fullWidth
              autoComplete="passwordConfirmation"
              variant="outlined"
              error={this.state.error.passwordConfirmation.length > 0}
              helperText={this.state.error.passwordConfirmation}
              onChange={e => this.handleFieldChange(e, 'passwordConfirmation')}
              inputProps={{ 'data-testid': 'passwordConfirmation' }}
              value={this.props.data.passwordConfirmation}
            />
          </Grid>
        </Grid>
      </div>
    );
  };

  render() {
    return (
      <div className="Confirmation">
        <div className="Wrapper">
          <p className="instructions">{this.props.languageStrings.confirmation.helperText}</p>

          <form onSubmit={this.nextStep}>
            {this.renderConfirmationControls()}

            <div className="Form-actions multiple">
              <Button
                disabled={this.props.submitting === true}
                variant="outlined"
                color="primary"
                onClick={e => {
                  this.previousStep(e);
                }}
              >
                {this.props.languageStrings.backButtonLabel}
              </Button>

              <Button disabled={this.isContinueDisabled()} variant="contained" color="primary" type="submit">
                {this.props.submitting ? (
                  <CircularProgress style={{ width: '24px', height: '24px' }} />
                ) : (
                  <span>{this.props.languageStrings.confirmation.submitButtonText}</span>
                )}
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default Confirmation;
